import access from './locales/en/access.json';
import chargers from './locales/en/chargers.json';
import common from './locales/en/common.json';
import dashboard from './locales/en/dashboard.json';
import settings from './locales/en/settings.json';

/**
 * Translations, bundled (no HTTP backend). One namespace per feature; `common` holds the shell and shared components.
 * A feature adds its keys to its own `locales/en/<feature>.json`.
 */
export const resources = {
  en: { common, dashboard, chargers, settings, access },
} as const;

export const defaultNS = 'common';
export const namespaces = Object.keys(resources.en) as (keyof (typeof resources)['en'])[];
export type Namespace = (typeof namespaces)[number];
export type FeatureNamespace = Exclude<Namespace, 'common'>;
